import React from 'react'
import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import Typography from '@mui/material/Typography'
import FormHelperText from '@mui/material/FormHelperText'
import { styled } from '@mui/material/styles'
import Grid from '@mui/material/Grid'

type Language = {
  name: string
  slug: string
  icon?: string
}

type LanguageProps = {
  title: string
  languages: Language[]
  selectedLanguages: Record<string, boolean>
  handleLanguageToggle: (slug: string, value: boolean) => void
  helperText?: string
  error?: boolean
}

const StyledFormHelperText = styled(FormHelperText)(({ theme }) => ({
  display: 'block',
  textAlign: 'center',
  marginTop: '5px',
  '&.error': {
    color: theme.palette.error.main,
  },
}))

export const EditLanguages: React.FC<LanguageProps> = ({
  title,
  languages,
  selectedLanguages,
  handleLanguageToggle,
  helperText,
  error,
}) => {
  return (
    <>
      <Typography variant="body1" fontWeight="bold" sx={{ marginBottom: '16px' }}>
        {title}
      </Typography>
      <Grid container rowSpacing={'16px'} columnSpacing={'70px'}>
        {languages.map((language) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            key={language.slug}
            sx={{
              '& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track': { backgroundColor: '#AE59C6!important' },
            }}
          >
            <FormControlLabel
              control={
                <Switch
                  checked={selectedLanguages[language.slug] || false}
                  onChange={(e) => handleLanguageToggle(language.slug, e.target.checked)}
                />
              }
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  {language.icon && <img src={language.icon} alt={language.name} style={{ width: '24px' }} />}
                  <Typography variant="body1" lineHeight={1}>
                    {language.name}
                  </Typography>
                </Box>
              }
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexDirection: 'row-reverse',
                marginRight: 0,
              }}
            />
          </Grid>
        ))}
      </Grid>
      {helperText && error && (
        <StyledFormHelperText className={error ? 'error' : ''}>{helperText}</StyledFormHelperText>
      )}
    </>
  )
}
